module.exports = __webpack_public_path__ + "static/step2_203-9bdb2aa58d3df16a567faed070ceabdf.png";